export default __webpack_public_path__ + "static/media/small-logo-light.ab3ababa.svg";